import { Button } from "acma-spa";
import React from "react";

export interface ProgressStageProps {
    edge?: 'first' | 'last';
    onPrevious: () => void;
    onNext: () => void;
    disabled?: boolean;
}

export const NextPreviousButtons = (props: ProgressStageProps) => {
  return (
    <div className="row mt-4" >
        <div className="col">
            <div className="d-flex justify-content-between">
                <Button label="Previous" mode="secondary" disabled={props?.edge === 'first'} onClick={props.onPrevious} />
                {props?.edge !== 'last' && <Button label="Next" className="ml-2" onClick={props.onNext} />}
                  {props?.edge === 'last' && <Button label="Finish and submit" className="ml-2" disabled={props.disabled} onClick={props.onNext} />}
            </div>
        </div>
    </div >
  );
}